import React from 'react'

import TableCell from '@/app/component/layout/table/cell'
import TableRow from '@/app/component/layout/table/row'
import { TCampaignListItem } from '@/app/module/campaigns/types'
import { TableHeader, TableSpecs } from '@/app/types'

import CampaignsTableField from './field'

type Props = {
  data: TCampaignListItem
  headers: TableHeader[]
  loading?: boolean
  specs: TableSpecs

  onClick: () => void
}

const Row: React.FC<Props> = ({ data, headers, loading, specs, onClick }) => {
  return (
    <TableRow isLoading={loading} onClick={onClick}>
      {headers.map(({ fields = [] }, i) => (
        <TableCell
          key={i}
          index={i}
          style={{
            height: '69px',
          }}
        >
          {fields.map((key) => (
            <CampaignsTableField key={key} field={data[key as keyof TCampaignListItem]} name={key} specs={specs[key]} />
          ))}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default Row
